import { FC } from 'react';

import { SocialLink } from '@/types';

import styles from './Footer.module.css';
import Icon from '../Icon/Icon';

const socialLinks: SocialLink[] = [
  {
    platform: 'LinkedIn',
    url: 'https://www.linkedin.com/in/sarafengland',
    icon: 'mdi:linkedin',
    label: 'Connect with me on LinkedIn',
  },
  {
    platform: 'GitHub',
    url: 'https://github.com/sarafengland',
    icon: 'mdi:github',
    label: 'View my projects on GitHub',
  },
];

const navLinks = [
  { name: 'Home', href: '#' },
  { name: 'Skills', href: '#skills' },
  { name: 'Achievements', href: '#achievements' },
  { name: 'Contact', href: '#contact' },
];

const Footer: FC = () => {
  return (
    <footer className={styles.footer} role="contentinfo">
      <div className={styles.footerContent}>
        <nav className={styles.footerNav} role="navigation" aria-label="Footer navigation">
          <ul className={styles.navList}>
            {navLinks.map(link => (
              <li key={link.name}>
                <a href={link.href} className={styles.navLink}>
                  {link.name}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div className={styles.rightSection}>
          <div className={styles.socialLinks} aria-label="Social media links">
            {socialLinks.map(link => (
              <a
                key={link.platform}
                href={link.url}
                aria-label={link.label}
                className={styles.socialLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon
                  icon={link.icon}
                  className={styles.socialIcon}
                  size="md"
                  aria-hidden={true}
                  aria-label={`${link.platform} Icon`}
                />
              </a>
            ))}
          </div>

          <div className={styles.divider} aria-hidden="true" />

          <p className={styles.copyright}>&copy; {new Date().getFullYear()} Sara England</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
